import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
const qs = require('qs')

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 120000
})

function getRequestMessage(error) {
  if (error && error.response && error.response.data) {
    return error.response.data.error || error.response.data.message
  }

  return (error && error.message) || 'Request failed'
}

service.interceptors.request.use(
  config => {
    config.vconfig = config.vconfig || {}

    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }

    if (config.vconfig.ContentType) {
      config.headers['Content-Type'] = config.vconfig.ContentType
    }

    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = qs.stringify(config.data)
    }

    if (config.vconfig.responseType) {
      config.responseType = config.vconfig.responseType
    }

    if (config.vconfig.cancel) {
      config.cancelToken = new axios.CancelToken(cancel => {
        cancel('cancel')
      })
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  res => {
    const code = res.data.code
    if (res.config.vconfig && res.config.vconfig.noErr) {
      return res
    }

    if (code === '-5' || res.data.error === 'please login') {
      MessageBox.confirm(
        'The login status has expired. You can stay on this page or log in again',
        'System prompt',
        {
          confirmButtonText: 'Login again',
          cancelButtonText: 'cancel',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('LogOut').then(() => {
          location.reload()
        })
      }).catch(() => {})

      return Promise.reject(res.data)
    } else if (+code !== 0) {
      Notification.error({
        title: res.data.error
      })
      return Promise.reject(res.data)
    }

    return res.data
  },
  error => {
    if (error.message !== 'cancel') {
      Message({
        message: getRequestMessage(error),
        type: 'error',
        duration: 5 * 1000
      })
    }

    return Promise.reject(error)
  }
)

export default service
